import gsap from 'gsap';

export default () => {
  let cards = document.querySelectorAll('.clients-item-link, .news .news-link, .related .news-link');
    const moreArticles = document.querySelectorAll('[data-page-name="NewsSingle"] .news-link');
    const moreArticlesWrapper = document.querySelector('[data-page-name="NewsSingle"] .news-inner');
    
  if (cards.length) {
    setCardTrigger(cards);
  }

  function setCardTrigger(items) {
    items.forEach(function(item, index) {
      let iter;
      item.classList.contains('clients-item-link')?iter=index*1.10:iter = index
      let t1 = gsap.timeline();
      
        t1.to(item, {
          opacity: 1,
          duration: 1,
          delay: .15 * iter
        })
      

    });
  }
  
  if (moreArticles.length) {
      
        const timeLine = gsap.timeline({
            scrollTrigger: {
                trigger: moreArticlesWrapper,
                start: 'top bottom-=150px',
            },
        })
        timeLine.to( '[data-page-name="NewsSingle"] .news-link', {
            opacity: 1,
            duration: 1,
            stagger: 0.15,
            ease: 'power1.easeOut'
          })
       
  }  
}